// The quiet backup reminder (Implementation Plan v02 §6.4; I-1a Batch 6b): a
// line on S33 when no backup file was made on this phone, or the last one is
// more than N days old (a content setting later; default 14). Never a pop-up,
// never a notification. The Home line waits for the real Home (I-1b).

export const BACKUP_REMINDER_DAYS = 14

/** 'never' = no backup made here; 'old' = older than `days`; null = no line. */
export type BackupReminder = 'never' | 'old' | null

const DAY = /^(\d{4})-(\d{2})-(\d{2})$/

function dayNumber(day: string): number | null {
  const match = DAY.exec(day)
  if (!match) {
    return null
  }
  return Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])) / 86_400_000
}

/** Both days as YYYY-MM-DD (local). An unreadable stored day counts as never. */
export function backupReminder(lastBackup: string | null, today: string, days: number = BACKUP_REMINDER_DAYS): BackupReminder {
  const last = lastBackup === null ? null : dayNumber(lastBackup)
  const now = dayNumber(today)
  if (last === null) {
    return 'never'
  }
  if (now === null) {
    return null
  }
  return now - last > days ? 'old' : null
}
